__turbopack_context__.v({
  "borderBottom": "Combobox-module__1OrRSq__borderBottom",
  "borderDefault": "Combobox-module__1OrRSq__borderDefault",
  "borderNone": "Combobox-module__1OrRSq__borderNone",
  "combobox": "Combobox-module__1OrRSq__combobox",
  "comboboxItem": "Combobox-module__1OrRSq__comboboxItem",
  "comboboxItemIcon": "Combobox-module__1OrRSq__comboboxItemIcon",
  "dropdownButton": "Combobox-module__1OrRSq__dropdownButton",
  "input": "Combobox-module__1OrRSq__input",
  "inputContainer": "Combobox-module__1OrRSq__inputContainer",
  "noLabel": "Combobox-module__1OrRSq__noLabel",
  "popover": "Combobox-module__1OrRSq__popover",
});
